module.exports = __webpack_public_path__ + "files/a3371af53ee2c143c45039323b035c6d.png";